export enum CartItemType {
    plan,
    item
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/shared/enums/CartItemType.ts